import { Toaster } from "react-hot-toast";

import { Logo } from "@calcom/ui";
import { FiCalendar, FiClock, FiCreditCard, FiGlobe } from "@calcom/ui/components/icon";

// import signupMock from "../../public/signup-mock.png";

export function GettingStartedLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div>
        <Toaster position="bottom-right" containerClassName="mr-16 md:mr-20" />
      </div>
      <div className="flex min-h-screen flex-col md:flex-row">
        {/* Left Column - Dark Background */}
        <div className="hidden flex-col bg-[#D1EBEB] p-6 md:flex md:w-2/5 md:min-w-96 md:p-10">
          <div className="mb-8">
            <Logo />
          </div>

          <div className="flex flex-1 flex-col">
            {/* <Image className="h-52 object-contain" alt="" src={signupMock} /> */}

            <div className="mx-auto mb-6 max-w-md">
              <h1 className="font-cal mb-6 text-2xl font-bold md:text-3xl">
                Entfalte dein volles Potential mit LuckyBrunch
              </h1>
              <p className="mb-8 text-black/80">
                Schließe dich unserer Plattform an und genieße die Vorteile flexibler Arbeitszeiten,
                Marketingunterstützung und beruflicher Wachstumschancen.
              </p>
            </div>

            <div className="mx-auto mb-12 flex max-w-md flex-col gap-6">
              <div className="flex items-start gap-4">
                <div className="text-brand-600 shrink-0">
                  <FiCalendar className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold">Einfache Terminverwaltung</h3>
                  <p className="text-sm text-black/60">durch unser integriertes Online-Buchungstool</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="text-brand-600 shrink-0">
                  <FiClock className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold">Zeitersparnis</h3>
                  <p className="text-sm text-black/60">
                    durch automatisierte Zahlungsabwicklung inkl. Rechnungsstellung
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className=" text-brand-600 shrink-0">
                  <FiGlobe className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold">Deine Internetpräsenz</h3>
                  <p className="text-sm text-black/60">
                    Baue dir ganz einfach eine eigene, SEO-optimierte Internetpräsenz auf
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="text-brand-600 shrink-0">
                  <FiCreditCard className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold">Keine Fixkosten</h3>
                  <p className="text-sm text-black/60">
                    LuckyBrunch erhebt nur eine Servicegebühr für gebuchte Leistungen
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Form */}
        <div className="bg-[#FDFCFA] p-6 md:grow md:p-10">
          <div className="mx-auto max-w-3xl">
            <div className="md:hidden">
              <Logo />
            </div>
            <div className="h-5 md:mb-8" />
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
